import BaseModel from "../core/BaseModel";
export default class WorkModel extends BaseModel {
  constructor() {
    super(
      {
        name: "work",
        tableName: "work",
        label: "Danh sách công việc (Work + Senario)",
        display_key: "name",
        default_order: { key: "created_at", direction: "asc" },
      },
      {
        stt: {
          name: "stt",
          label: "STT",
          type: "Computed",
          computed: (data, index) => {
            data.stt = index + 1;
          },
        },
        id: { 
            name: 'id', 
            type: "Uuid", 
            label: 'ID', 
            primaryKey: true,
            display: false
        },
        department: {
          name: "department",
          label: "Bộ phận",
          type: "MultiSelect",
          filter: {
            type: "SelectScroll",
            optionLabel: "name",
            optionKey: "id",
            match: "equals",
          },
        },
        name: {
            name: 'name',
            type: "TEXT",
            label: 'Tên công việc',
            sortable: false,
            // width: 20,
            filter: {type: 'input',match: 'contains'}
        },
        count_total: {
          name: 'count_total',
          type: "INT", 
          label: 'SL tình huống',
          display: false,
        },
        total_situation: {
          name: 'total_situation',
          type: "CustomUrl", 
          label: 'SL tình huống',
          class: 'center',
          sortable: false,
          width: 10,
          computed: (data) => {
            data.total_situation = 0;
          }
        },
        active : {
          name: 'active', 
          type: "Selection", 
          custom: 'SelectionText',
          label: 'Hiển thị',
          class: 'center',
          width: 6,
          options: [
            {label: "Hiển thị",value: true},
            {label: "Ẩn",value: false}
          ],
          filter: { type: 'select', optionLabel: 'label', optionKey: 'value', match: 'equals' }
        },
        updated_name : {
          name: 'updated_name', 
          type: "TEXT", 
          label: 'Người cập nhật',
          width : 10,
        },
        updated_at: {
          name: "updated_at",
          type: "Datetime",
          label: "Cập nhật cuối",
          width : 10,
          // filter: { type: "DateRange", match: "contains" },
        },
        created_at: {
          name: "created_at",
          type: "Datetime",
          label: "Ngày tạo",
          filter: { type: "DateRange", match: "contains" },
          display: false,
        }
      }
    );
  }
}
